module.exports = __webpack_public_path__ + "static/img/er.7b2d3410.svg";